export default "__VITE_ASSET__D_gWm4Ke__"